import { Icon } from '@iconify/react';

import { PATH_DASHBOARD } from '../../routes/paths';
import SvgIconStyle from '../../components/shared/SvgIconStyle';


const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const getIconifyIcon = (name) => {
  return (
    <Icon icon={name} fontSize={42}  />
  )
};

const ICONS = {
  home: getIcon('ic_dashboard'),
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  bot: getIcon('ic_chat'),
  faq: getIcon('ic_list'),
  tov: getIcon('ic_user_voice'),
  settings: getIcon('ic_settings'),
  tickets: getIcon('ep--tickets'),
  admin: getIcon('ic_user'),
  escalations: getIconifyIcon('mdi:alert-decagram-outline'),
  processingReport: getIconifyIcon('mdi:chart-box-outline'),
  initialDecisions: getIconifyIcon('mdi:clipboard-check-outline'),
  resultEvals: getIconifyIcon('mdi:clipboard-text-search-outline'),
  memoryCreationLogs: getIconifyIcon('mdi:brain'),
  answerAugmentations: getIconifyIcon('mdi:text-box-check-outline'),
  customFlows: getIconifyIcon('material-symbols:flowchart-outline-sharp'),
  selling: getIconifyIcon('material-symbols:add-shopping-cart-rounded'),
  actions: getIconifyIcon('mdi:arrow-right-bold-circle-outline')
};


const adminItems = [
  {
    title: 'Admin',
    path: PATH_DASHBOARD.general.admin,
    icon: ICONS.admin,
    end: true,
  },
  {
    title: 'Escalations',
    path: PATH_DASHBOARD.general.adminEscalations,
    icon: ICONS.escalations,
  },
  {
    title: 'Processing Report',
    path: PATH_DASHBOARD.general.adminProcessingReport,
    icon: ICONS.processingReport,
  },
  {
    title: 'Result Evals',
    path: PATH_DASHBOARD.general.adminResultEvals,
    icon: ICONS.resultEvals,
  },
  {
    title: 'Memory Creation Logs',
    path: PATH_DASHBOARD.general.adminMemoryCreationLogs,
    icon: ICONS.memoryCreationLogs,
  },
  {
    title: 'Answer Augmentations',
    path: PATH_DASHBOARD.general.adminAnswerAugmentations,
    icon: ICONS.answerAugmentations,
  }
];

export const adminSection = {
  subheader: 'admin',
  items: adminItems
};

const sidebarConfig = [
  {
    subheader: '',
    items: [
      { title: 'Dashboard', path: PATH_DASHBOARD.general.home, icon: ICONS.home },
      { title: 'Statistics', path: PATH_DASHBOARD.general.stats, icon: ICONS.analytics },
      { title: 'Tickets', path: PATH_DASHBOARD.general.tickets, icon: ICONS.tickets },
      { title: 'Playground', path: PATH_DASHBOARD.general.playground, icon: ICONS.bot },
      { title: 'QA Policies', path: PATH_DASHBOARD.general.qa, icon: ICONS.faq },
      { title: 'Tone Of Voice', path: PATH_DASHBOARD.general.tov, icon: ICONS.tov },
      {
        title: 'Actions',
        path: PATH_DASHBOARD.general.settingsActions,
        icon: ICONS.actions,
      },
      {
        title: 'Custom Flows',
        path: PATH_DASHBOARD.general.settingsFlows,
        icon: ICONS.customFlows,
      },
      {
        title: 'Settings',
        icon: ICONS.settings,
        children: [
          {
            title: 'General',
            path: PATH_DASHBOARD.general.settings,
            icon: ICONS.settings,
          },
          {
            title: 'Integrations',
            path: PATH_DASHBOARD.general.settingsConnectors,
            icon: ICONS.settings,
          },
          {
            title: 'Automation',
            path: PATH_DASHBOARD.general.settingsAutomation,
            icon: ICONS.settings,
          },
          {
            title: 'Products',
            path: PATH_DASHBOARD.general.settingsProduct,
            icon: ICONS.settings,
          },
          {
            title: 'Billing',
            path: PATH_DASHBOARD.general.settingsBilling,
            icon: ICONS.settings,
          },
        ]
      }
    ]
  }
];

export default sidebarConfig;
